import type { WorkingTreeChangeFileRow } from '../../../git/changes/index.js';

export function parseWorkingTreeChangeKind(value: unknown): WorkingTreeChangeFileRow['change'] | null {
  if (value === 'added' || value === 'removed' || value === 'modified' || value === 'moved') return value;
  return null;
}
